import { render } from "./EditImgProfileFormComponent.vue?vue&type=template&id=1340a61a&scoped=true"
import script from "./EditImgProfileFormComponent.vue?vue&type=script&lang=js"
export * from "./EditImgProfileFormComponent.vue?vue&type=script&lang=js"

import "./EditImgProfileFormComponent.vue?vue&type=style&index=0&id=1340a61a&scoped=true&lang=css"

import exportComponent from "D:\\Cotizador Frontend\\dyc_cotizador_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1340a61a"]])

export default __exports__